import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
//import {Route} from "vue-router";

Vue.config.productionTip = false;
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
    routes: routes,
    linkActiveClass: 'active',
    mode: 'history',
    hash: false,
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {selector: to.hash};
        }
        return {x: 0, y: 0};
    }
});

export default router;
